export default __webpack_public_path__ + "bbe48a45148214cf1f7cdf1c6294f62a.svg";